<template>
  <div>
    <tr>
      <td class="tabla_venta_producto text_right color_nombre">{{ color.color_nombre }}</td>
      <td class="tabla_venta_cantidad">{{ color.cantidad }}</td>
      <td class="tabla_venta_monto">${{ dotsCadaTres(parseFloat(color.precio_total).toFixed(2).replace(/\.00$/, '')) }}</td>
      <td class="tabla_venta_sub_desglosado">{{ color.cantidad_socio }}</td>
      <td class="tabla_venta_sub_desglosado">${{ dotsCadaTres(parseFloat(color.facturado_socio).toFixed(2).replace(/\.00$/, '')) }}</td>
      <td class="tabla_venta_sub_desglosado">{{ color.cantidad_no_socio }}</td>
      <td class="tabla_venta_sub_desglosado">${{ dotsCadaTres(parseFloat(color.facturado_no_socio).toFixed(2).replace(/\.00$/, '')) }}</td>
    </tr>
  </div>
</template>

<script>
export default {
  name: 'ProductoListaItemTalleColor',
  components: {
  },
  props: ['color'],
  data: function () {
    return {
    }
  },
  methods: {
    dotsCadaTres (dni) {
      const number = dni.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      return number
    }
  },
  computed: {
    // imagenRuta: function () {
    //   return `${PATH_IMG}/${this.comercio.imagen}`
    // }
  }
}
</script>
